import { inputs } from "../../../../inputs/inputConfigs";

export default {
  groups: [
    {
      items: [{ input: inputs.poVendorNotes }],
    },
  ],
};
